/*
 * Translation-Key-Prefix:
 *   - "unit.<NAME>"
 *   - "unit.<NAME>.short" (Optional)
 *   - "pdf.invoice.unit.short.<NAME>"
 */
export enum ItemUnit {

  // ##########################################################################
  // #### Holzindustrie / Wood industry
  // ##########################################################################
  // Kubikmeter (m^3)
  CUBIC_METER = 'CUBIC_METER',
  // Schüttraummeter (SRm) / Loose cubic meters (LCM)
  LOOSE_CUBIC_METERS = 'LOOSE_CUBIC_METERS',
  // Raummeter (RM) / Stacked cubic meter (stacked m^3)
  STACKED_CUBIC_METER = 'STACKED_CUBIC_METER',
  // Festmeter (FM) / solid cubic meter (solid m^3)
  SOLID_CUBIC_METER = 'SOLID_CUBIC_METER',
  // Ster / Stere
  STERE = 'STERE',
  // ##########################################################################
  // #### Allgemein / General
  // ##########################################################################
  // Stueck
  PIECE = 'PIECE',
  // Satz
  RATE = 'RATE',
  // AW / Arbeitswert
  LABOR_VALUE = 'LABOR_VALUE',
  // STD / Stunde
  HOUR = 'HOUR',
  // ZE / Zeiteinheit
  TIME_UNIT = 'TIME_UNIT',
  // Zentiliter (cl) / 1/100 Liter
  CENTILITER = 'CENTILITER',
  // Milliliter (ml) / 1/1000 Liter
  MILLILITER = 'MILLILITER',
  // Liter
  LITER = 'LITER',
  // Millimeter (mm) / 1/1000 Meter
  MILLIMETER = 'MILLIMETER',
  // Zentimeter (cm) / 1/100 Meter
  CENTIMETER = 'CENTIMETER',
  // Meter
  METER = 'METER',
  // Kilometer (km) / 1000 Meter
  KILOMETRE = 'KILOMETRE',
  // Milligramm (mg) / 0.001 g
  MILLIGRAM = 'MILLIGRAM',
  // Gramm (g)
  GRAM = 'GRAM',
  // Kilogramm (kg) / 1000g
  KILOGRAM = 'KILOGRAM',
  // Tonne (t) / 1000kg
  TON = 'TON'
}
